import React from 'react';

const PollHeader = React.memo(({ title, description }) => (
    <div className="text-center mb-4">
        <h1 className="rakete-font fs-4 rakete-rot fw-semibold mb-2">{title}</h1>
        {description && <p className="text-secondary m-4">{description}</p>}
    </div>
));

export default PollHeader;